import React, {useState} from 'react';
import '../styles/index.css';
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarToggler,
    MDBIcon,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBCollapse
} from 'mdb-react-ui-kit';
import Logo from '../images/Logo-v2-cropped.png';
import { useLanguage } from '../context/LanguageContext.js';


export default function Header() {
    const [showBasic, setShowBasic] = useState(false);
    const { language, toggleLanguage } = useLanguage();

    return (
        <MDBNavbar expand='lg' light bgColor='light'>
            <MDBContainer fluid>
                <MDBNavbarBrand href='.'>
                    <img
                        src={Logo}
                        height='60'
                        alt=''
                        loading='lazy'
                    />
                    SOLEXPRES
                </MDBNavbarBrand>

                <MDBNavbarToggler
                    aria-controls='navbarSupportedContent'
                    aria-expanded='false'
                    aria-label='Toggle navigation'
                    onClick={() => setShowBasic(!showBasic)}
                >
                    <MDBIcon icon='bars' fas/>
                </MDBNavbarToggler>

                <MDBCollapse navbar show={showBasic}>
                    <MDBNavbarNav right fullWidth={false} className='mb-2 mb-lg-0' id='navbar-right-content'>
                        <MDBNavbarItem>
                            <MDBNavbarLink href='#about-container'>
                                {language === 'EN' ? 'About us' : 'Despre noi'}
                            </MDBNavbarLink>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <MDBNavbarLink href='#service-container'>
                                {language === 'EN' ? 'Services' : 'Servicii'}
                            </MDBNavbarLink>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                            <MDBNavbarLink href='#contact-container'>
                                {language === 'EN' ? 'Contacts' : 'Contacte'}
                            </MDBNavbarLink>
                        </MDBNavbarItem>
                        <MDBNavbarItem className='vertical-line'>
                            <div 
                                className='language-switcher d-flex align-items-center'
                                style={{ cursor: 'pointer', padding: '10px 1rem 0.5rem 0' }}
                            >
                                <span 
                                    onClick={language === 'RO' ? toggleLanguage : undefined}
                                    style={{ 
                                        fontWeight: language === 'EN' ? '600' : '400',
                                        color: language === 'EN' ? '#000000' : '#b0b0b0',
                                        marginRight: '0.5rem',
                                        cursor: language === 'RO' ? 'pointer' : 'default'
                                    }}
                                >
                                    English
                                </span>
                                <span style={{ color: '#b0b0b0', margin: '0 0.25rem' }}>|</span>
                                <span 
                                    onClick={language === 'EN' ? toggleLanguage : undefined}
                                    style={{ 
                                        fontWeight: language === 'RO' ? '600' : '400',
                                        color: language === 'RO' ? '#000000' : '#b0b0b0',
                                        marginLeft: '0.5rem',
                                        cursor: language === 'EN' ? 'pointer' : 'default'
                                    }}
                                >
                                    Română
                                </span>
                            </div>
                        </MDBNavbarItem>
                    </MDBNavbarNav>
                </MDBCollapse>
            </MDBContainer>
        </MDBNavbar>
    );
}